import React, { useEffect, useState } from "react";
import { Button } from 'react-bootstrap';
import { getForIndex } from "../utils/axios";
import TemplatesTable from "./TemplatesTable";

const Templates = (props) => {
	const [recordState, setRecordState] = useState({ data: [], currentPage: 1, totalMatches: 0, totalPages: 0, perPage: 250, filter: { textFilter: '' }, loadingInProgress: true })

	const getData = () => { getForIndex('/admin/templates', recordState, setRecordState) }

	useEffect(() => { getData() }, []);

	return (
		<>
			<Button onClick={() => props.history.push('/m1/admin/templates/new')} className='pull-right' type='submit' bsStyle='primary' bsSize='small'>New Template</Button>
			<h3 className="first-title">Email Templates</h3>
			<div>
				{recordState.data.length === 0
					? <h5>No matching records</h5>
					: <TemplatesTable
						items={recordState.data}
					/>
				}

			</div>

		</>

	);
}

export default Templates
